const state = {
  status: 'loading',
  error: null,
  data: {},
  singleData: {},
  invDetails: {},
  deliveryPersonList: {},
  delivered: {},
  invoiceItemData: {},
  addInvoiceItemsData: {},
  editInvoiceItemsData: {},
  order: {}
};

export default state;
